exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-default {\r\n    background-color: #5c7080;\r\n    border: none;\r\n    border-radius: 5px;\r\n    color: #f5f8fa;\r\n    font-size: 15px;\r\n    padding: 6px 6px;\r\n}\r\n\r\n.billing-provider-drawer .bp3-drawer-body .bp3-dialog-body .grid .bp3-tabs .bp3-tab-panel .multi-select-panel .multi-select-panel-header .input-tag span {\r\n    line-height: inherit;\r\n}\r\n", ""]);

// exports
